import { fmtMsg } from "commonui";
import { MessageHelper } from "./../../../commonui/utils/messagehelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Icon, Drawer, Button, Select, Input, Form, Table, AutoComplete, Tooltip, Modal, Radio } from "ant-design-vue";
import {
	ContentExposureLocale,
	CommonLocale,
	CommonEntitiesLocale,
	ContentExposureTeachObjLocale
} from "@/locales/localeid";
import ContentExposurepositionAction from "@/components/content-exposure/content-exposure-position-action/content-exposure-position-action.vue";
import { TeachingActivityService, TeachingActivityModel } from "@/services/teaching-activity";
import RichTextEditor from "@/components/rich-text-editor/rich-text-editor.vue";
import { sortBy, uniqBy } from "lodash";
import draggable from "vuedraggable";
import { deepClone, pureRichText } from "@/util/func";
import { NotificationType, ServerExceptionCode, ActionItem } from "commonui";
import { RTEItems } from "@/components/rich-text-editor/rich-text-editor";
import { v4 } from "uuid";
import { WrappedFormUtils } from "ant-design-vue/types/form/form";
import ContentImageEditor from "../../content-image-editor/content-image-editor.vue";
import IContentImageEditor from "../../content-image-editor/content-image-editor";
import { ImageMetaData } from "@/models/image-meta-data";
import { ImageViewerModal, ImageViewerModalRef } from "@/components/image-viewer-modal";
import { VCSLevelModel } from "@/models/title-list-model";
import { ContentExposureRelatedItemType } from "@/util/enum";

export interface ContentExposureActivityProps {
	isEdit?: boolean;
	isAnyEdit?: boolean;
	initValues?: any[];
}

@Component({
	components: {
		Icon,
		Form,
		Table,
		Drawer,
		Button,
		Select,
		draggable,
		AutoComplete,
		Item: Form.Item,
		TextArea: Input.TextArea,
		Option: Select.Option,
		ContentExposurepositionAction,
		RichTextEditor,
		ActionItem,
		Tooltip,
		ContentImageEditor,
		ImageViewerModal,
		Radio,
		RadioGroup: Radio.Group
	}
})
export default class ContentExposureActivity extends Vue {
	@Prop() versionGroupId!: string;
	@Prop({ default: "" }) contentId!: string;
	@Prop({ default: () => {} }) content!: { id: string; title: string; vcsLevelId: number };
	@Prop({ default: false }) isEdit!: boolean;
	@Prop({ default: false }) isAnyEdit!: boolean;
	@Prop({ default: () => [] }) initValues!: any[];
	@Prop({ default: false }) showTooltip!: boolean; // to all disable tooltip permanently
	@Prop({ default: 0 }) unitId!: number;
	@Prop({ default: () => [] }) units!: VCSLevelModel[];
	@Prop({ default: () => [] }) relatedItems!: any[];
	@Prop({ default: () => [] }) exposureObjectives!: any[];

	teachingActivityService = TeachingActivityService();
	teachingActivities: TeachingActivityModel[] = [];
	selectedActivities: TeachingActivityModel[] = [];
	visible = false;
	loading = false;
	addActivityForm!: WrappedFormUtils;
	editActivityForm!: WrappedFormUtils;
	customData = {
		id: "-1",
		text: "Custom",
		isCommon: true,
		contentExposures: [],
		versionGroupId: this.versionGroupId
	};
	multilineData = {
		id: "-2",
		text: "Custom Multiline",
		isCommon: true,
		contentExposures: [],
		versionGroupId: this.versionGroupId
	};
	defaultActivity: null | TeachingActivityModel = null;
	defaultActivityId: null | string = null;
	private maxActivityLength = 4000;
	editorMenuItems = [RTEItems.bold, RTEItems.italic, RTEItems.underline];
	loadingCommonActivities = false;
	savingCustomAcitivites = false;
	isDrawerOpened: null | boolean = null;
	editIndex?: null | number = null;
	selectedPageImageId?: string = "";
	isMasteryDrawerOpen: boolean = false;
	selectedObjectiveId?: string | null = this.exposureObjectives.length ? this.exposureObjectives[0].objectiveId : "";
	selectedTeachingActivityId: string = "";

	rules = [
		{ required: true, message: fmtMsg(CommonLocale.CommonFieldRequired, { name: this.ActivityText }) },
		{
			max: this.maxActivityLength,
			message: fmtMsg(CommonLocale.CommonFieldLength, { name: this.ActivityText, value: this.maxActivityLength }),
			trigger: "change"
		},
		{ validator: this.validateTitle, trigger: "change" }
	];

	multilineRules = [
		{ required: true, message: fmtMsg(CommonLocale.CommonFieldRequired, { name: this.ActivityText }) },
		{ validator: this.validateMultiline, trigger: "change" }
	];
	public fmtMsg = fmtMsg;
	public contentExposureLocale = ContentExposureLocale;

	public columns: any[] = [
		{
			title: fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesOrder),
			dataIndex: "sequence",
			key: "sequence",
			width: "10%",
			className: "sequence-column"
		},
		{
			title: fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesActivity),
			dataIndex: "text",
			key: "text",
			width: "45%"
		},
		{
			title: fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesEdit),
			dataIndex: "position",
			key: "edit",
			width: "10%"
		},
		{
			title: fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesImage),
			dataIndex: "position",
			key: "image",
			width: "10%"
		},
		{
			title: fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesMastery),
			dataIndex: "position",
			key: "mastery",
			width: "12.5%"
		},
		{
			title: fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesRemove),
			dataIndex: "position",
			key: "remove",
			width: "12.5%"
		}
	];

	tooltipVisible = false;
	locale = CommonLocale;

	multilineEditorExtentions = [
		RTEItems.bold,
		RTEItems.italic,
		RTEItems.underline,
		RTEItems.link,
		RTEItems.hardBreak,
		RTEItems.heading,
		RTEItems.bulletList,
		RTEItems.listItem
	];

	selectedImageActivity: TeachingActivityModel = {
		id: "",
		text: "",
		isCommon: false,
		versionGroupId: "",
		contentExposures: [],
		sequence: 0
	};
	cancelText = fmtMsg(ContentExposureTeachObjLocale.Cancel);
	updateText = fmtMsg(ContentExposureTeachObjLocale.Update);
	insertText = fmtMsg(ContentExposureTeachObjLocale.Insert);
	imageViewerSrc: string = "";
	imageViewerMetaData?: ImageMetaData = {
		x: 0,
		y: 0,
		width: 0,
		height: 0,
		rotate: 0,
		scaleX: 0,
		scaleY: 0,
		annotations: []
	};

	$refs!: {
		content: HTMLDivElement;
		imageEditor: IContentImageEditor;
		liteViewer: ImageViewerModalRef;
	};

	created() {
		if (!this.addActivityForm) {
			this.addActivityForm = this.$form.createForm(this, { name: "addActivityForm" });
		}
		if (!this.editActivityForm) {
			this.editActivityForm = this.$form.createForm(this, { name: "editActivityForm" });
		}
	}

	mounted() {
		const parent = this.$refs.content.parentNode as HTMLTableCellElement;
		if (parent) {
			parent.addEventListener("dblclick", this.onDoubleClick);
			parent.addEventListener("mouseenter", this.onMouseEnter);
			parent.addEventListener("mouseleave", this.onMouseLeave);
		}
	}

	beforeDestroy() {
		const parent = this.$refs.content.parentNode as HTMLTableCellElement;
		if (parent) {
			parent.removeEventListener("dblclick", this.onDoubleClick);
			parent.removeEventListener("mouseenter", this.onMouseEnter);
			parent.removeEventListener("mouseleave", this.onMouseLeave);
		}
	}

	onDoubleClick() {
		!this.isEdit && this.$emit("doubleClick");
	}

	onMouseEnter() {
		this.tooltipVisible = true;
	}

	onMouseLeave() {
		this.tooltipVisible = false;
	}

	get activities() {
		return this.initValues.map((v) => {
			const linkedExposureObjectiveIds = this.exposureObjectives.map((obj) => obj.objectiveId);
			// Remove association with objective id if it isn't present in exposure objectives.
			if (linkedExposureObjectiveIds.length && !linkedExposureObjectiveIds.includes(v.objectiveId)) {
				v.objectiveId = null;
			}
			v.title = pureRichText(v.text);
			return v;
		});
	}

	get drawerTitle() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesTitle);
	}

	get addNewActivity() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesAddNewActivity);
	}

	get AddText() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesAdd);
	}

	get ActivityText() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesActivity);
	}

	get ImageSubmitText() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesImageSubmit);
	}

	get ImageCancelText() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesImageCancel);
	}

	get chapterIds() {
		return this.relatedItems
			.filter((item) => item.type === ContentExposureRelatedItemType.Chapter)
			.map((item) => item.contentId);
	}

	getActivityTitle(activity) {
		return pureRichText(activity.text);
	}

	searchValue(activity) {
		return `${activity.text}\t${activity.id}`;
	}

	async getTeachingActivitiesStatistic() {
		const params = {
			isCommon: true,
			versionGroupIds: [this.versionGroupId]
		};
		this.loadingCommonActivities = true;
		const activities = await this.teachingActivityService.getTeachingActivitiesStatistic(params);
		this.loadingCommonActivities = false;
		this.setTeachingActivity(activities);
	}

	@Watch("visible")
	getTeachingActivities() {
		if (!this.visible) {
			this.addActivityForm.resetFields();
			return;
		}
		this.defaultActivityId = null;
		this.defaultActivity = null;
		this.editIndex = null;
		this.selectedActivities = this.initValues.map((v, k) => {
			const linkedExposureObjectiveIds = this.exposureObjectives.map((obj) => obj.objectiveId);
			// Remove association with objective id if it isn't present in exposure objectives.
			if (linkedExposureObjectiveIds.length && !linkedExposureObjectiveIds.includes(v.objectiveId)) {
				v.objectiveId = null;
			}
			return {
				...v,
				sequence: k + 1
			};
		});
		this.getTeachingActivitiesStatistic();
	}

	validateTitle(rule, value, callback) {
		const formatValue = pureRichText(value);
		if (formatValue && !formatValue.trim()) {
			callback(fmtMsg(CommonLocale.CommonFieldRequired, { name: "text" }));
			return;
		}
		callback();
	}

	/**
	 * Splits the multiline string value into separate objectives.
	 * @param value Multiline value
	 * @returns {string[]}
	 */
	getDataFromLiTags(value: string): string[] {
		// get all the values inside li tags
		const values = value
			.trim()
			.replace(/\\n/g, " ")
			.match(/\<([\s]+|[\s]?)li\>.*?\<\/([\s]+|[\s]?)li\>/g);

		if (values) {
			return values
				.map((m) => {
					// remove li tags from start and end
					return this.removeLiTagsFromStartAndEnd(m).trim();
				})
				.filter((f) => f && f.length);
		} else {
			const values = pureRichText(value);
			if (values.length) {
				return [value.trim()];
			}
		}

		return [];
	}

	/**
	 * Retuns the regex of space match and empty li tag removal
	 * @returns {{spaceRegex: string, removal: RegExp}}
	 */
	getRegexpForEmptyLiRemoval(): { spaceRegex: string; removal: RegExp } {
		const spaceRegex = "([s]?|[s]+)"; // Note: Extensive use of '([\s]?|[\s]+)' space matcher in regex,
		return {
			spaceRegex,
			removal: new RegExp(
				`\<${spaceRegex}li${spaceRegex}\>${spaceRegex}\<${spaceRegex}\/${spaceRegex}li${spaceRegex}\>`,
				"g"
			)
		};
	}

	/**
	 * Removes li tags from start and end of string and empty li tags
	 * @param value {string}
	 * @returns {string}
	 */
	removeLiTagsFromStartAndEnd(value: string): string {
		const spaceRegex = "([s]?|[s]+)";
		// remove <li> from start and </li> from end
		// and process as other nodes were processed using 'activitiesFromCustomMultiline'
		const liRegex = new RegExp(`^\<${spaceRegex}li${spaceRegex}\>`, "g");
		const liCloseRegex = new RegExp(`\<${spaceRegex}\/${spaceRegex}li${spaceRegex}\>$`, "g");
		return value
			.replace("<li><p></p></li>", "")
			.replace(this.getRegexpForEmptyLiRemoval().removal, "")
			.trim()
			.replace(liRegex, "")
			.replace(liCloseRegex, "");
	}

	/**
	 * Processes content while user pastes
	 * @public
	 * @param value
	 * @param previousValue
	 * @returns {string}
	 */
	beforePasteValueUpdate(value: string, previousValue: string): string {
		previousValue = previousValue
			.trim()
			.replace("<li><p></p></li>", "")
			.replace(this.getRegexpForEmptyLiRemoval().removal, "");
		// get previous items (allready added in rich text area)
		const previousActivities = this.getDataFromLiTags(previousValue);

		let activities = "";
		// split on '</ul>' tag
		const allActivities = this.getDataFromLiTags(value);
		const newActivities = allActivities.slice(previousActivities.length);
		if (newActivities && newActivities.length) {
			// means a new value is added
			// process as other nodes were processed using 'activitiesFromCustomMultiline'
			const splittedNewActi = newActivities.map((a) => {
				a = this.removeLiTagsFromStartAndEnd(a);
				return this.activitiesFromCustomMultiline(a);
			});

			// SelectMany
			const pActivities: string[] = [];
			splittedNewActi.forEach((f) => {
				if (Array.isArray(f)) {
					pActivities.push(...f);
				} else {
					pActivities.push(f);
				}
			});

			// get unique activities
			const allNonUniqActivities = [...previousActivities, ...pActivities];
			const allNewActivities = this.uniqueActivities(allNonUniqActivities);

			if (allNonUniqActivities.length !== allNewActivities.length) {
				this.showAllreadyPresentMessage(allNonUniqActivities.length - allNewActivities.length);
			}

			// join previous and new activities
			activities = allNewActivities
				.map((m) => {
					return "<li>" + m.trim() + "</li>";
				})
				.join("");

			return "<ul>" + activities + "</ul>";
		} else if (previousActivities.length != 0) {
			// means value is not added. So return the value itself
			return value;
		} else {
			// process value itself
			activities = this.activitiesFromCustomMultiline(value)
				.map((m) => {
					return "<li>" + m.trim() + "</li>";
				})
				.join("");
			return "<ul>" + activities + "</ul>";
		}
	}

	/**
	 * Returns unique activities
	 * @param activities {string[]}
	 * @returns {string[]}
	 */
	uniqueActivities(activities: string[]): string[] {
		return uniqBy(activities, (v) => {
			return pureRichText(v).toLowerCase();
		});
	}

	/**
	 * Validates a multiline input.
	 * Called by antd library's form component.
	 * @param rule Rule against which the validation has to done.
	 * @param value Value of the field
	 * @param callback Callback when validation success or fail
	 * @returns
	 */
	validateMultiline(rule, value: string, callback: (msg?: string) => void) {
		if (!value) {
			callback();
			return;
		}
		// Validates the multiline entry
		const allActivities = this.getDataFromLiTags(value);
		let message: string | undefined = undefined;
		let current = 0;
		// check length of each activity and call 'validateTitle'
		while (current < allActivities.length) {
			this.validateTitle(rule, allActivities[current], (msg?: string) => (message = msg));
			message = message as string;
			if (allActivities[current].length > this.maxActivityLength) {
				message = fmtMsg(ContentExposureLocale.ContentExposureTeachingAcitivityLengthExceeds, {
					length: this.maxActivityLength
				});
			}
			if (message && message.length) {
				break;
			}
			current++;
		}

		if (message) {
			callback(message);
			return;
		}
		callback();
	}

	/**
	 * Sanitizes the objectives
	 * when user pastes into the multiline editor
	 * @param value Value from Multiline editor
	 * @returns {string[]}
	 */
	activitiesFromCustomMultiline(value: string): string[] {
		if (!value || !value.length) {
			return [];
		}

		const char = "•"; // It was defined in the story GL-8907
		const wordChar = "·"; // when copied from word document or publisher

		// Below are private unicode chars. (Private unicode chars are reserved for private use, and intepreted by the software)
		// More: http://www.unicode.org/faq/private_use.html
		const privateUnicode = "[\ue000-\uf8ff]+";

		const allValues = value
			.replace(/\r\n|\r|\n|<p>|<\/p>/g, " ")
			.trim()
			.split(new RegExp(`${char}|${wordChar}|${privateUnicode}`, "gmu"))
			.map((m) =>
				m
					.replace(/^(&nbsp;)+|(&nbsp;)+$/gi, " ") // remove extra space tags from start and end
					.replace(/[\s]{2,}/gm, " ") // remove extra spaces
					.replace(/^<br[\/]?>|<[\/]?br>$/gi, "") // remove line break from start and end
					.replace(/[\ue000-\uf8ff]+/g, "") // remove all private characters
					.replace(/<p><\/p>/, "") // remove empty p tags
					.trim()
			)
			.filter((f) => pureRichText(f).replace("&nbsp;", "").trim().length) // remove lines with only &nbsp html entity;
			.filter((f: string) => f.length);
		return this.uniqueActivities(allValues);
	}

	setTeachingActivity(activities) {
		this.teachingActivities = sortBy(activities, "text");
		this.teachingActivities.unshift(this.multilineData);
		this.teachingActivities.unshift(this.customData);
	}

	addSelectedTeachingActivity(activity) {
		if (
			this.selectedActivities.some(
				(a) => pureRichText(a.text).trim().toLowerCase() === pureRichText(activity.text).trim().toLowerCase()
			)
		) {
			MessageHelper.Message(
				NotificationType.Failed,
				fmtMsg(ContentExposureLocale.ContentExposureTeachingActivityHasSelected)
			);
			return;
		}

		const sequence = this.selectedActivities.length;
		this.selectedActivities.push({
			...activity,
			sequence: sequence + 1
		});
	}

	/**
	 * Shows a message that n activities already exists.
	 * @param count {number}
	 */
	showAllreadyPresentMessage(count: number) {
		MessageHelper.Message(
			NotificationType.Warning,
			fmtMsg(ContentExposureLocale.ContentExposureTeachingActivityExists, {
				count
			})
		);
	}

	/**
	 * Adds multiple activities to the list
	 * @param activities
	 */
	addMultipleSelectedTeachingActivity(activities: any[]) {
		// filter activities already added
		const filteredActivities = activities.filter(
			(f) =>
				!this.selectedActivities.find(
					(s) => pureRichText(s.text).trim().toLowerCase() === pureRichText(f.text).trim().toLowerCase()
				)
		);
		const allreadyPresent = activities.length - filteredActivities.length;
		if (allreadyPresent) {
			this.showAllreadyPresentMessage(allreadyPresent);
		}

		const sequence = this.selectedActivities.length;
		const seqActivity = filteredActivities.map((m, index) => {
			return {
				...m,
				sequence: sequence + index + 1
			};
		});

		this.selectedActivities = [...this.selectedActivities, ...seqActivity];
	}

	setSelectedTeachingActivities(activities) {
		this.selectedActivities = activities.map((activity, key) => {
			return {
				...activity,
				sequence: key + 1
			};
		});
	}

	showErrorMessage(error_code) {
		if (error_code == ServerExceptionCode.TargetHasExistedException) {
			MessageHelper.Message(
				NotificationType.Warning,
				fmtMsg(CommonEntitiesLocale.CommonTeachingActivityTextHasExisted)
			);
		}
	}

	onAddActivity() {
		if (!this.defaultActivityId) {
			MessageHelper.Message(
				NotificationType.Failed,
				fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesTips)
			);
			return;
		}
		if (this.defaultActivityId == this.customData.id) {
			this.addActivityForm.validateFields((err, values) => {
				if (!err) {
					const params = {
						id: v4(),
						isCommon: false,
						text: values.text
							.trim()
							.replace(/^<p>|<\/p>$/g, "") // remove p tags from each activity
							.replace(/<\/p><p>|<p><\/p>/g, "<br/>") // replace empty p tags with "br" tag
							.replace(/^<br[\/]?>|<[\/]?br>$/g, ""), // remove br from starting and end
						versionGroupId: this.versionGroupId,
						contentId: this.contentId,
						isNew: true
					};
					this.addSelectedTeachingActivity(params);
				} else {
					console.log(err);
				}
			});
		} else if (this.defaultActivityId == this.multilineData.id) {
			this.addActivityForm.validateFields((err, values) => {
				if (!err) {
					let allActivities = this.getDataFromLiTags(values.multilineText.trim());
					// remove 'p' tag from start and end. Since the editor is adding paragraph inside li tags
					allActivities = allActivities
						.map((m) => m.replace(/^([\s]*(\<p\>)+[\s]*)+|([\s]*(\<\/p\>)+[\s]*)+$/gi, "").trim())
						.map((m) => m.replace(/<\/p><p>/gm, "<br>")) // replace any '</p><p>' with 'br' tag.
						.filter((f) => f.length);
					const params = allActivities.map((m) => ({
						id: v4(),
						isCommon: false,
						text: m.trim(),
						versionGroupId: this.versionGroupId,
						contentId: this.contentId,
						isNew: true
					}));
					this.addMultipleSelectedTeachingActivity(params);
				} else {
					console.log(err);
				}
			});
		} else {
			const selectedActivity = this.teachingActivities.find((a) => a.id == this.defaultActivityId);
			this.addSelectedTeachingActivity(selectedActivity!);
		}
	}

	onRemove(activity: TeachingActivityModel) {
		const index = this.selectedActivities.findIndex((a) => a.id == activity.id);
		this.selectedActivities.splice(index, 1);
		this.selectedActivities.map((a, key) => {
			a.sequence = key + 1;
			return a;
		});
	}

	onEditClick(index: number) {
		this.editIndex = index;
	}

	onEditActivity(activity: TeachingActivityModel & { isNew?: boolean }) {
		this.editActivityForm.validateFields((err, values) => {
			if (!err) {
				const params = {
					id: v4(),
					isCommon: false,
					text: values.text
						.trim()
						.replace(/^<p>|<\/p>$/g, "") // remove p tags from each activity
						.replace(/<\/p><p>|<p><\/p>/g, "<br/>") // replace empty p tags with "br" tag
						.replace(/^<br[\/]?>|<[\/]?br>$/g, ""), // remove br from starting and end
					versionGroupId: this.versionGroupId,
					contentId: this.contentId,
					isNew: true,
					sequence: activity.sequence,
					imageUrl: activity.imageUrl,
					imageName: activity.imageName,
					pageId: activity.pageId,
					metaData: activity.metaData,
					objectiveId: activity.objectiveId
				};
				this.editActivity(params);
			}
		});
	}

	editActivity(activity: TeachingActivityModel) {
		if (
			this.selectedActivities.some(
				(a) =>
					a.sequence !== activity.sequence &&
					pureRichText(a.text).trim().toLowerCase() === pureRichText(activity.text).trim().toLowerCase()
			)
		) {
			MessageHelper.Message(
				NotificationType.Failed,
				fmtMsg(ContentExposureLocale.ContentExposureTeachingActivityHasSelected)
			);
			return;
		}
		const sequence = this.editIndex as number;
		Vue.set(this.selectedActivities, sequence, {
			...activity,
			sequence: activity.sequence
		});
		this.onCancelEdit();
	}

	onCancelEdit() {
		this.editIndex = null;
	}

	handleChange(value) {
		const activity = value && value.split("\t");
		this.defaultActivityId = activity && activity.pop();
		this.defaultActivity = activity && activity.join(" ");
	}

	showDrawer() {
		this.visible = true;
	}

	onClose() {
		const close = () => {
			this.visible = false;
			this.addActivityForm.resetFields();
			this.editActivityForm.resetFields();
			this.selectedImageActivity = {
				id: "",
				text: "",
				isCommon: false,
				versionGroupId: "",
				contentExposures: [],
				sequence: 0
			};
		};

		if (this.editIndex !== null) {
			Modal.confirm({
				title: fmtMsg(ContentExposureTeachObjLocale.ConfirmInsertEditWarn),
				okText: fmtMsg(ContentExposureTeachObjLocale.ConfirmOkTxt),
				cancelText: fmtMsg(ContentExposureTeachObjLocale.ConfirmCancelTxt),
				onOk: close
			});
		} else {
			close();
		}
	}

	openImageEditor(teachingActivity: TeachingActivityModel) {
		this.selectedImageActivity = teachingActivity;
		let metadata: ImageMetaData | undefined;
		if (teachingActivity.metaData) {
			metadata = JSON.parse(teachingActivity.metaData);
		}
		this.$refs.imageEditor.startEditing(metadata);
	}

	onImageAttach(item: { name: string; type: string; pageId: string; source: string; metaData: ImageMetaData }) {
		if (this.selectedImageActivity && this.selectedImageActivity.id) {
			const activities = deepClone(this.selectedActivities) as TeachingActivityModel[];
			const activity = activities.find((act) => act.id === this.selectedImageActivity.id);

			const isDefaultMetaData = ({ x, y, height, width, rotate, scaleX, scaleY, annotations }: ImageMetaData) => {
				return (
					x === 0 &&
					y === 0 &&
					height === 0 &&
					width === 0 &&
					rotate === 0 &&
					scaleX === 1 &&
					scaleY === 1 &&
					!annotations?.length
				);
			};

			if (activity) {
				activity.pageId = item.pageId;
				activity.imageName = item.name;
				activity.imageUrl = item.source;

				if (item.metaData && !isDefaultMetaData(item.metaData)) {
					activity.metaData = JSON.stringify(item.metaData);
				} else {
					activity.metaData = undefined;
				}
			}

			this.selectedActivities = [...activities];
		}

		this.resetImageData();
	}

	onRemoveImage() {
		const activities = deepClone(this.selectedActivities) as TeachingActivityModel[];

		const activity = activities.find((act) => act.id === this.selectedImageActivity.id);

		if (activity) {
			activity.pageId = undefined;
			activity.imageName = undefined;
			activity.imageUrl = undefined;
			activity.metaData = undefined;
		}

		this.selectedActivities = [...activities];
		this.resetImageData();
	}

	onImageEditCancel() {
		this.resetImageData();
	}

	onPageImageEdit(teachingActivity: TeachingActivityModel) {
		this.selectedPageImageId = teachingActivity.pageId;
		this.openImageEditor(teachingActivity);
	}

	onLiteViewerClick(item: TeachingActivityModel) {
		this.imageViewerSrc = item.imageUrl || "";
		if (item.metaData) {
			this.imageViewerMetaData = JSON.parse(item.metaData);
		} else {
			this.imageViewerMetaData = undefined;
		}
		this.$refs.liteViewer.open();
	}

	onLiteViewerClose() {
		this.imageViewerSrc = "";
		this.imageViewerMetaData = undefined;
	}

	private resetImageData() {
		this.selectedPageImageId = "";
		this.selectedImageActivity = {
			id: "",
			text: "",
			isCommon: false,
			versionGroupId: "",
			contentExposures: [],
			sequence: 0
		};
	}

	async onSubmit() {
		this.onClose();
		this.selectedActivities.forEach((v, k) => {
			v.sequence = k + 1;
		});
		this.$emit("submit", deepClone(this.selectedActivities));
	}

	openMasteryDrawer(item: TeachingActivityModel) {
		this.selectedTeachingActivityId = item.id;
		this.selectedObjectiveId = item.objectiveId ?? null;
		this.isMasteryDrawerOpen = true;
	}

	onMasteryDrawerClose() {
		this.isMasteryDrawerOpen = false;
	}

	onObjectiveSelection(e) {
		this.selectedObjectiveId = e.target.value;
	}

	onMasteryDrawerSave() {
		this.selectedActivities.map((a) => {
			if (a.id === this.selectedTeachingActivityId) {
				a.objectiveId = this.selectedObjectiveId;
			}
			return a;
		});
		this.isMasteryDrawerOpen = false;
	}
}
